import TableCellBranch from "ds/components/Table/Row/CellBranch";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModulePullRequestsTableRow } from "../../../gql";
import ModulePullRequestsTableGroupCell from "../../GroupCell";

const ModulePullRequestsTablePullRequestBranchCell = ({
  item: pullRequest,
  ...cellProps
}: TableSimpleCellProps<ModulePullRequestsTableRow>) => {
  return (
    <ModulePullRequestsTableGroupCell item={pullRequest} {...cellProps}>
      <TableCellBranch href={pullRequest.headBranchURL}>{pullRequest.headBranch}</TableCellBranch>
    </ModulePullRequestsTableGroupCell>
  );
};

export default ModulePullRequestsTablePullRequestBranchCell;
